import http from '../helpers/http';

export default class SupervisorRepository {

    getDivisions(lastDownloadedDate) {
        return http.post('/api/v1/supervisor/divisions', {
            divisionsLastDownloaded: lastDownloadedDate
        })
    }

    getData(serialNumber, divisionID, supervisorDataLastDownloaded) {
        return http.post('/api/v1/supervisor/data', {
            serialNumber,
            divisionID,
            supervisorDataLastDownloaded
        }).then(data => {
            data.lastFetched = new Date();
            return data;
        });
    }

    getDivisionLocations(serialNumber, divisionID) {
        return http.post('/api/v1/supervisor/locations', {
            serialNumber,
            divisionID
        });
    }

    getCompetences(serialNumber, divisionID, projectID, siteCode, zoneCode) {
        return http.post('/api/v1/supervisor/competences', {
            serialNumber,
            divisionID,
            projectID,
            siteCode,
            zoneCode
        });
    }

    getAwardableCompetences(serialNumber, divisionID, projectID, siteCode, zoneCode, categoryID) {
        return http.post('/api/v1/supervisor/awardableCompetences', {
            serialNumber,
            divisionID,
            projectID,
            siteCode,
            zoneCode,
            categoryID
        });
    }
}